<template>
  <div>
    <sc-text tag="div" class="quote" v-if="fields && fields.quote" :field="fields.quote" />
    <sc-text
      tag="div"
      class="quote__source"
      v-if="fields && fields.source"
      :field="fields.source"
    />
  </div>
</template>

<script>
import { Text } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Blockquote-Carousel-Item',
  components: {
    ScText: Text
  },
  props: {
    fields: {
      type: Object
    }
  }
};
</script>
<style lang="scss" scoped>
.quote {
  @include font-styles('Arial', 1.8rem, 200, italic, 2.4rem, 0, $dark-blue);
  margin-bottom: 2rem;

  @include tablet-up {
    font-size: 2.4rem;
    line-height: 3.6rem;
  }

  &__source {
    display: inline-block;
    @include font-styles('Arial', 1.6rem, 500, normal, 2rem, 0, $dark-blue);

    @include tablet-up {
      font-size: 2rem;
      line-height: 2.6rem;
    }
  }
}
</style>
